import React from 'react'
import PropTypes from 'prop-types'
import { useLatestJobExecutionStatus } from '../../../../../api/integrations'
import Loading from '../../../../molecules/Loading'
import BasicTable from '../../../../atoms/BasicTable'
import NullValue from '../../../../molecules/NullValue'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'
import JobActions from './JobActions'

function Job ({ job }) {
  const { data, isFetching, refetch } = useLatestJobExecutionStatus(job.sourceKey, job.jobKey)
  const { formatter } = useFormattingContext()
  const exec = data?.executionStatus
  return (
    <tr>
      <td className='px-2'>{job.jobKey}</td>
      <td className='px-2'>{exec?.description ?? job.description}</td>
      <td className='px-2' onClick={refetch}>{isFetching ? <Loading size={10} /> : exec?.executionStatus ?? '--'}</td>
      <td className='px-2' onClick={refetch}>{isFetching ? <Loading size={10} /> : formatter(exec?.startedOn, 'timestamp')}</td>
      <td className='px-2' onClick={refetch}>{isFetching ? <Loading size={10} /> : formatter(exec?.finishedOn, 'timestamp')}</td>
      <td className='px-2' onClick={refetch}>{isFetching ? <Loading size={10} /> : formatter(exec?.lastActivityOn, 'timestamp')}</td>
      <td className='px-2'>
        {exec?.metrics?.length ? (
          <BasicTable className='border-neutral-thin'>
            {exec.metrics.map((metric) => (
              <tr key={metric.executionMetricId}>
                <td>{metric.code}</td>
                <td className='px-2'>{metric.value}</td>
              </tr>
            ))}
          </BasicTable>
        ) : <NullValue value='No Metrics' />}
      </td>
      <td className='px-2'><JobActions job={job} /></td>
    </tr>
  )
}

Job.propTypes = {
  job: PropTypes.object
}

export default Job
